exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\napp-footer{\r\n    display: block;\r\n}\r\n\r\n.bg-info{\r\n    background-color: #ffffff !important;\r\n}\r\n\r\n.bg-info a{\r\n    color: #000 !important;\r\n}\r\n\r\n.submitBtn{\r\n    background: #5C462B !important;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles